import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import AccordionItem from './AccordionItem'
import { addHyperlinkTitle } from '../../../../../common/helpers'
import { Section } from 'src/components/shared/SectionV2'

const sleep = (ms) => new Promise((r) => setTimeout(r, ms))

const Accordion = ({ items, title }) => {
  const itemRefs = useRef([])
  const previousItemCount = useRef(items.length)
  const [marked, setMarked] = useState()

  useEffect(() => {
    if (items.length < previousItemCount.current) {
      setMarked(undefined)
    }

    previousItemCount.current = items.length
  }, [items.length])

  const handleChangeCollapse = async (id) => {
    if (id === marked) {
      setMarked(undefined)
    } else {
      setMarked(id)
      if (itemRefs.current[id - 1]) {
        await sleep(200)
        itemRefs.current[id - 1].scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  if (!(items.length > 2)) return null

  return (
    <div data-testid="faq-accordion">
      <div>
        {title ? (
          <Section.Typography
            as="h2"
            variant="heading-large"
            data-testid="accordion-title"
            className="mb-6"
          >
            {title}
          </Section.Typography>
        ) : null}
        <div data-testid="item-list" className="border-b border-gray-540">
          {items.map((f, i) => {
            const { title: question, content } = f

            addHyperlinkTitle(content?.content, question)

            return (
              <div ref={(el) => (itemRefs.current[i] = el)} key={i}>
                <AccordionItem
                  title={question}
                  content={content}
                  id={i}
                  opened={marked === i}
                  changeCollapse={handleChangeCollapse}
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

Accordion.defaultProps = {
  items: [],
  showFirstDivider: false,
}
Accordion.propTypes = {
  items: PropTypes.array,
  title: PropTypes.string,
}

export default Accordion
